module.exports = __webpack_public_path__ + "static/media/hexa-thumbnail.18053312.jpg";